/**
 * Kleine Auszeichnungen fuer Rollen, Familien und Hinweise.
 *
 * Bewusst zurueckhaltend: Gruen markiert, es faerbt nicht die Flaeche
 * (CORPORATE_DESIGN.md 7.2). Eine datenreiche Liste bleibt ruhig.
 *
 * Die Beschriftungen kommen von aussen. Familiennamen sind fachliche
 * Datenwerte und werden unveraendert durchgereicht; Rollenbeschriftungen
 * werden vom Aufrufer aus dem Code abgeleitet.
 */
import { useT } from "../i18n/index.tsx";
import "./Badges.css";

export function RoleBadge({ label }: { label: string }): React.JSX.Element {
  return <span className="badge badge--role">{label}</span>;
}

export function FamilyBadge({ label, primary }: { label: string; primary: boolean }): React.JSX.Element {
  const t = useT();
  return (
    <span className={primary ? "badge badge--family badge--primary" : "badge badge--family"}
          title={t(primary ? "badge.primaryFamily" : "badge.secondaryFamily")}>
      {label}
    </span>
  );
}

export function FlagBadge({ count }: { count: number }): React.JSX.Element | null {
  const t = useT();
  if (count <= 0) return null;
  return (
    <span className="badge badge--flag" title={t("badge.openFlagsTitle", { count })}>
      {t("badge.openFlags", { count })}
    </span>
  );
}
